import { openDB } from 'idb';

const DB_NAME = 'lidwork-offline';
const DB_VER  = 2;

export async function getDb() {
  return openDB(DB_NAME, DB_VER, {
    upgrade(db, oldVer) {
      if (oldVer < 1) {
        db.createObjectStore('drafts', { keyPath: 'localId' });
        db.createObjectStore('ap_cache', { keyPath: 'semaine' });
      }
      if (oldVer < 2) {
        db.createObjectStore('photoq', { keyPath: 'qid' });
      }
    }
  });
}

export async function saveDraft(draft) {
  const db = await getDb();
  draft.localId = draft.localId || `draft_${Date.now()}`;
  draft.updatedAt = new Date().toISOString();
  await db.put('drafts', draft);
  return draft.localId;
}
export async function getDraft(localId) { return (await getDb()).get('drafts', localId); }
export async function getAllDrafts()    { return (await getDb()).getAll('drafts'); }
export async function deleteDraft(id)   { return (await getDb()).delete('drafts', id); }

// ── File de photos hors-ligne ─────────────────────────────────────
// {qid, blob, name, target:{kind:'ap'|'zone', key}, createdAt}
export async function queuePhoto(blob, name, target) {
  const db = await getDb();
  const qid = `q_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  await db.put('photoq', { qid, blob, name, target, createdAt: Date.now() });
  return qid;
}
export async function getQueuedPhotos() { return (await getDb()).getAll('photoq'); }
export async function removeQueuedPhoto(qid) { return (await getDb()).delete('photoq', qid); }
export async function queueSize() { return (await getDb()).count('photoq'); }
